<template>
  <div class="gs-player-section">
    <gs-field label="When the video ends" hint="What the player does after the last frame.">
      <div class="gs-radio-cards" role="radiogroup" aria-label="When the video ends">
        <label
          v-for="action in endActions"
          :key="action.value"
          class="gs-radio-card"
          :class="{ 'is-selected': isSelected(action.value) }"
        >
          <input
            type="radio"
            class="gs-radio-card__input"
            :name="'end-action-' + _uid"
            :value="action.value"
            :checked="isSelected(action.value)"
            :data-end-action="action.value"
            @change="changeEndAction(action.value)"
          />
          <span class="gs-radio-card__title">{{ action.text }}</span>
          <span class="gs-radio-card__help">{{ action.help }}</span>
        </label>
      </div>
    </gs-field>
  </div>
</template>

<script>
export default {
  name: 'EndActionSection',

  props: {
    model: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      // The values the API stores, kept as the strings step1's `<select>` wrote.
      endActions: [
        { value: '1', text: 'Just end', help: 'The player stops on the last frame.' },
        { value: '2', text: 'Loop the video', help: 'It starts again from the beginning.' },
      ],
    };
  },

  methods: {
    isSelected(value) {
      return String(this.model.end_actions) === value;
    },

    // Ported from step1.
    changeEndAction(value) {
      this.model.end_actions = value;
      this.$store.dispatch('videoEndAction', this.model.end_actions);
      this.$store.dispatch('videoComponentKey');
      this.$emit('updateModel', this.model);
      this.$emit('forceRerender');
    },
  },
};
</script>

<style scoped>
.gs-player-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 14px;
}

.gs-radio-cards {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.gs-radio-card {
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 4px;
  padding: 16px 42px 16px 16px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-md);
  cursor: pointer;
}

.gs-radio-card.is-selected {
  background: var(--gs-active-soft);
  border-color: var(--gs-active-border);
}

.gs-radio-card__input {
  position: absolute;
  top: 16px;
  right: 16px;
  accent-color: var(--gs-active);
}

.gs-radio-card__title {
  color: var(--gs-foreground);
  font-size: 14px;
  font-weight: 650;
}

.gs-radio-card__help {
  color: var(--gs-muted-foreground);
  font-size: 13px;
  line-height: 1.5;
}

@media (max-width: 640px) {
  .gs-radio-cards {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
